import React, { act, useEffect, useState } from "react";
import Header from "../Components/header";
import Footer from "../Components/footer";
import { GraphQLClient } from "graphql-request";
import Regalo from "./regalo";
import logo from "../imgs/package_icon.png";
import {
  useParams,
  Navigate,
  useLocation,
  useHistory,
  useNavigate,
} from "react-router-dom";
import { subscribe, checkCoupon, sendGift } from "./api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

//TODO Pulsante rinnovo

const AbbCartaceo = () => {
  const { slug } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [product, setAbbonamento] = useState(null);
  const [error, setError] = useState(false);
  const [isLogged, setIsLogged] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [giftCode, setGiftCode] = useState("");
  const [couponError, setCouponError] = useState(null);
  const [activeTab, setActiveTab] = useState("riscatta");
  const [sendOption, setSendOption] = useState("direct");
  const [nomeDestinatario, setNomeDestinatario] = useState("");
  const [emailDestinatario, setEmailDestinatario] = useState("");
  const [messaggio, setMessaggio] = useState("");

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === "invia") {
      setSelectedOption(null);
    }
  };

  const handleSendOptionChange = (e) => {
    setSendOption(e.target.value);
  };

  const handleInputChange = (e) => {
    setGiftCode(e.target.value);
  };

  const handleSendGift = async () => {
    console.log("EMAIL DESTINATARIO:", emailDestinatario);
    if (!emailDestinatario) {
      console.log("Inserisci un'email valida.");
      return;
    }
    console.log("Opzione selezionata: ", sendOption);
    if (sendOption === "direct") {
      console.log("Invia direttamente");
      console.log("Email destinatario a:", emailDestinatario);
      console.log("Nome destinatario: ", nomeDestinatario);
      console.log("Messaggio: ", messaggio);
      const data = {
        id_prodotto: product.id,
        sendOption: sendOption,
        email_destinatario: emailDestinatario,
        nome_destinatario: nomeDestinatario,
        messaggio: messaggio,
        isGift: true,
      };
      try {
        //sendGift(data);
        navigate("/checkout-regalo", {
          state: {
            //isGift: true, id_prodotto: product.id
            data,
          },
        });
        console.log("Regalo inviato con successo!");
      } catch (error) {
        console.log("Errore nell'invio del regalo:", error);
      }
    } else if (sendOption === "self") {
      console.log("Invia come regalo");
      //console.log("Email destinatario a:", emailDestinatario);
      console.log("Nome destinatario: ", nomeDestinatario);
      console.log("Messaggio: ", messaggio);
    }
  };

  useEffect(() => {
    console.log("SELECTED:", selectedOption);
  }, [selectedOption]);

  const handleSubscribe = async (id_rivista, selectedOption, coupon) => {
    try {
      if (coupon) {
        const response = await checkCoupon(coupon);
        console.log("RESPONSE:", response);

        if (response.valid) {
          const data = {
            id_rivista: id_rivista,
            selectedOption: selectedOption,
            coupon: coupon,
          };
          console.log("DATA:", data);
          console.log("SLUG:", slug);
          navigate("/subscribe-checkout", {
            state: { data, from: "/abbonamenti/" + slug },
          });
        } else {
          console.log("Coupon non valido:", response.messaggio);
          setCouponError(response.messaggio);
        }
      } else {
        const data = {
          id_rivista,
          selectedOption,
        };
        console.log("Dati inviati:", data);

        // Naviga verso la pagina di checkout
        console.log("SLUG:", slug);
        navigate("/subscribe-checkout", {
          state: { data, from: "/abbonamenti/" + slug },
        });
      }
    } catch (err) {
      console.log("Errore durante la richiesta:", err);
    }
  };

  useEffect(() => {
    const fetchProduct = async () => {
      const client = new GraphQLClient(
        "https://api-eu-central-1-shared-euc1-02.hygraph.com/v2/clweq2m6a000001w67aqzeh7x/master"
      );
      const query = `query MyQuery($slug: String!) {
        abbonamentis(where: { slugAbbonamento: $slug }) {
          titolo
          id
          prezzo
          copertina {
            url
          } 
        }
      }
      `;

      try {
        const data = await client.request(query, { slug });
        if (data.abbonamentis.length === 0) {
          setError(true);
        } else {
          const productData = data.abbonamentis[0];
          const img = new Image();
          img.src = productData.copertina.url;
          img.onload = () => {
            setAbbonamento(productData);
            setIsLoading(false);
          };
          img.onerror = () => {
            setError(true);
            setIsLoading(false);
          };
        }
        console.log(product);
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    };

    fetchProduct();
  }, []);

  if (isLoading) {
    return (
      <div className="flex flex-col min-h-screen">
        <Header />
        <div className=" flex flex-col justify-center items-center">
          <div className="grid cols-1 md:grid-cols-2 gap-8 p-12 w-screen bg-gresen-500">
            <div className="mr-20 justify-self-end">
              <Skeleton width={"340px"} height={"100%"} />
            </div>
            <div className="text-left md:mr-10 bg-bluse-500">
              <Skeleton width={"100%"} height={"10%"} />
              <p className="text-xl font-bold text-gray-500 mt-2">
                <Skeleton width={"10%"} height={"10%"} />
              </p>
              <p className="mt-10 text-lg text-gray-700">
                <Skeleton width={"40%"} height={"10%"} />
              </p>
              <div className="grid grid-cols-2 gap-2  p-5 rounded-xl">
                <Skeleton width={"100%"} height={"150px"} />
                <Skeleton width={"100%"} height={"150px"} />
              </div>
              <Skeleton width={"100%"} height={"5%"} />
              <Skeleton width={"100%"} height={"10%"} className="mt-5" />
              <Skeleton width={"100%"} height={"10%"} className="mt-5" />

              <div className="text-md text-gray-500 my-10 "></div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (!isLogged) {
    // Solo se id_rivista non è null
    console.log("Slug: ", slug);
    if (product.id !== null) {
      return (
        <Navigate
          to="/login"
          state={{ from: location, previousLocation: "/" + slug }}
        />
      );
    }
    // Se id_rivista è null, puoi decidere cosa fare (ad esempio, reindirizzare a una pagina predefinita)
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className=" flex flex-col justify-center items-center">
        <div className="grid cols-1 md:grid-cols-2 gap-8 p-12 w-screen bg-greeen-500">
          <div className="mr-20 justify-self-end">
            <img
              src={product.copertina.url}
              //alt={product.copertina.fileName}
              className="w-full h-auto mx-auto max-w-full sm:max-w-sm md:max-w-md lg:max-w-lg"
              style={{
                maxWidth: "400px",
                maxHeight: "500px",
                minHeight: "90px",
                minWidth: "90px",
              }}
            />
          </div>
          <div className="text-left md:mr-10 bg-bluse-500">
            <p className="text-3xl font-bold mb-4 text-gray-700">
              {product.titolo}
            </p>

            <p className="text-xl font-bold text-gray-500 mt-2">
              € {product.prezzo}
            </p>
            {product.titolo === "Abbonamento digitale" ? (
              <div className="w-full  ">
                <p className="text-lg text-gray-700">
                  Questo abbonamento può essere acquistato su PocketMags
                </p>
                <a
                  href="https://pocketmags.com/it/modellistica-international-magazine"
                  target="_blank"
                  rel="noreferrer"
                  className="flex w-full my-5 font-bold text-center justify-center items-center border-4 text-red-500 border-red-500 hover:text-white hover:bg-red-500 h-12 transition"
                >
                  ABBONATI
                </a>
              </div>
            ) : (
              <div>
                <p className="mt-10 text-lg font-semibold text-gray-600">
                  Opzioni di acquisto
                </p>
                {
                  //<div className="grid grid-cols-2 gap-2 bg-gray-100 p-5 rounded-xl border border-gray-500">
                }
                <div className="grid grid-cols-2 gap-2 mt-2">
                  <button
                    onClick={() => setSelectedOption("onetime")}
                    disabled={activeTab === "invia"}
                    className={` border ${
                      selectedOption == "onetime"
                        ? "border-blue-500"
                        : "" || activeTab === "invia"
                        ? "bg-gray-300"
                        : "bg-white hover:shadow-[0_0px_5px_1px_rgba(0,0,0,0.4)]"
                    } text-black py-8 px-4 rounded flex flex-col justify-center items-center transition-all duration-200`}
                  >
                    <svg
                      width="70"
                      height="70"
                      xmlns="http://www.w3.org/2000/svg"
                      fillRule="evenodd"
                      clipRule="evenodd"
                      viewBox="0 0 70 70"
                      className={`fill-current transition duration-300 ${
                        selectedOption === "onetime"
                          ? "text-blue-500"
                          : "text-gray-500"
                      }`}
                    >
                      <path d="M8.686 24.378 0 16.742 25.395 2.917l9.745 6.84 9.362-6.84L70 16.447l-8.791 7.817.041.023L70 36.289l-8.75 4.766v12.022L35 67.083 8.75 53.077V41.075l2.917 1.587v8.665l21.878 11.672v-23.01L26.25 50.59 0 36.319zm27.775 15.651v22.969l21.872-11.671v-8.683L43.75 50.589zM4.314 35.344l21.023 11.428 5.387-7.828-21.09-10.915zm34.968 3.637 5.378 7.79 21.023-11.454-5.314-7.286zM11.64 25.783l23.362-12.921 23.331 12.942-23.248 12.113zm-6.58-8.475 6.142 5.399 20.883-11.53L25.2 6.344zm32.88-5.985 20.638 11.378 6.347-5.644L44.748 6.35z" />
                    </svg>

                    <p className="text-gray-600 font-semibold">
                      Abbonamento annuale
                    </p>
                  </button>
                  <button
                    onClick={() => setSelectedOption("recurring")}
                    disabled={activeTab === "invia"}
                    className={` border ${
                      selectedOption == "recurring"
                        ? "border-blue-500"
                        : "" || activeTab === "invia"
                        ? "bg-gray-300"
                        : "bg-white hover:shadow-[0_0px_5px_1px_rgba(0,0,0,0.4)]"
                    } text-black py-8 px-4 rounded flex flex-col justify-center items-center transition-all duration-200`}
                  >
                    <svg
                      width="70"
                      height="70"
                      xmlns="http://www.w3.org/2000/svg"
                      fillRule="evenodd"
                      clipRule="evenodd"
                      viewBox="0 0 70 70"
                      className={`fill-current transition duration-300 ${
                        selectedOption === "recurring"
                          ? "text-blue-500"
                          : "text-gray-500"
                      }`}
                    >
                      <path d="M5.833 34.245A16.01 16.01 0 0 1 0 21.875C0 13.02 7.187 5.833 16.042 5.833a16.01 16.01 0 0 1 12.37 5.833h12.421a2.917 2.917 0 0 1 2.917 2.917v5.833h13.612c3.258 0 4.667 1.68 5.647 3.229 1.732 2.742 4.48 7.093 6.151 9.852.548.91.84 1.954.84 3.019v13.067c0 3.372-1.797 5.833-5.833 5.833H61.25a8.753 8.753 0 0 1-17.5 0H32.083a8.753 8.753 0 0 1-17.5 0H8.75a2.917 2.917 0 0 1-2.917-2.917zm17.5 17.672a3.503 3.503 0 0 1 0 7 3.503 3.503 0 0 1 0-7m29.167 0a3.503 3.503 0 0 1 0 7 3.503 3.503 0 0 1 0-7M31.48 17.5a16.047 16.047 0 0 1-19.813 19.813v12.27h5.148a8.75 8.75 0 0 1 6.518-2.916 8.75 8.75 0 0 1 6.519 2.917h16.129a8.75 8.75 0 0 1 6.519-2.917 8.75 8.75 0 0 1 6.519 2.917h5.148V36.24l-4.99-8.543a2.92 2.92 0 0 0-2.518-1.447H43.75v17.5h-5.833V17.5zm15.187 11.667v8.75H61.25l-4.162-7.28a2.92 2.92 0 0 0-2.532-1.47zm-30.625-17.5c5.635 0 10.208 4.573 10.208 10.208s-4.573 10.208-10.208 10.208S5.833 27.51 5.833 21.875s4.574-10.208 10.209-10.208m1.458 8.75h5.833v2.917h-8.75v-8.751H17.5z" />
                    </svg>

                    <p className="text-gray-600 font-semibold">
                      Abbonamento con rinnovo automatico
                    </p>
                  </button>
                </div>

                <div className="flex flex-col items-center w-full">
                  <Regalo
                    giftCode={giftCode}
                    handleInputChange={handleInputChange}
                    couponError={couponError}
                    activeTab={activeTab}
                    handleTabChange={handleTabChange}
                    emailDestinatario={emailDestinatario}
                    setEmailDestinatario={setEmailDestinatario}
                    sendOption={sendOption}
                    setSendOption={setSendOption}
                  />
                  {/* Form visibile solo se activeTab è "regalo" */}
                  <div
                    className={`${
                      activeTab === "invia"
                        ? "max-h-[500px] opacity-100"
                        : "max-h-0 opacity-0"
                    } block transition-[max-height,opacity] duration-500 ease-linear overflow-hidden w-full max-w-lg mt-4`}
                  >
                    {/* Contenuto del form per invio come regalo */}
                    <div className="flex flex-col space-y-4">
                      <input
                        type="text"
                        placeholder="Nome destinatario"
                        id="nomeDestinatario"
                        value={nomeDestinatario}
                        onChange={(e) => setNomeDestinatario(e.target.value)}
                        className="transition duration-300 block border p-2 border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-blue-500 sm:text-sm"
                      />

                      <textarea
                        placeholder="Messaggio (opzionale)"
                        value={messaggio}
                        onChange={(e) => setMessaggio(e.target.value)}
                        className="transition duration-300 block border p-2 border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-blue-500 sm:text-sm"
                      />
                    </div>

                    <div className="mt-4">
                      <label className="flex items-center space-x-2">
                        <input
                          type="radio"
                          name="sendOption"
                          value="direct"
                          onChange={handleSendOptionChange}
                          checked={sendOption === "direct"}
                          default
                          className="accent-blue-500 w-4 h-4"
                        />
                        <span>Invia direttamente al destinatario</span>
                      </label>

                      <label className="flex items-center space-x-2 mt-2">
                        <input
                          type="radio"
                          name="sendOption"
                          value="self"
                          onChange={handleSendOptionChange}
                          checked={sendOption === "self"}
                          className="accent-blue-500 w-4 h-4"
                        />
                        <span>Invia a me per inoltrarlo</span>
                      </label>
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      if (activeTab === "riscatta") {
                        handleSubscribe(product.id, selectedOption, giftCode);
                      } else {
                        handleSendGift();
                      }
                    }}
                    className={`${
                      activeTab === "riscatta"
                        ? " border-red-500 w-full  bg-white font-bold border-4 text-red-500 hover:text-white hover:bg-red-500"
                        : "mt-5 border-green-500 w-full bg-green-500 text-white py-2 px-4 rounded-md shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                    }    h-12 transition-all duration-300 ease-linear`}
                    disabled={!selectedOption && activeTab === "riscatta"}
                    style={{
                      width: activeTab === "riscatta" ? "100%" : "50%", // Cambia width dinamicamente

                      //opacity: activeTab === "riscatta" ? "100%" : "0%",
                    }}
                  >
                    {activeTab === "riscatta"
                      ? "ABBONATI"
                      : "Invia come regalo"}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        {product.titolo !== "Abbonamento digitale" ? (
          <div className="bg-gray-50 p-6 rounded-md shadow-md my-4 max-w-4xl">
            <p className="text-lg font-semibold mb-4 text-gray-800">
              Abbonamento a Modellistica International
            </p>
            <p className="text-gray-700 mb-4">
              Modellistica è una rivista con cadenza bimestrale. L'abbonamento
              annuale comprende 6 uscite al prezzo di{" "}
              <span className="font-semibold">€43,00</span>.
            </p>

            <p className="text-gray-800 font-medium mb-2">
              Altri metodi di pagamento
            </p>
            <div className="flex justify-center">
              <ul className="list-disc list-inside text-gray-700 mb-4 text-left max-w-lg ">
                <li>
                  Con bonifico bancario a{" "}
                  <span className="font-semibold">International Press</span>{" "}
                  <br />
                  IBAN:{" "}
                  <span className="font-mono">IT43C0503424873000000279621</span>
                </li>
                <li>
                  Con bollettino postale sul conto{" "}
                  <span className="font-semibold">399550</span> intestato a
                  "Modellistica International Periodico"
                </li>
              </ul>
            </div>

            <div className="flex justify-center">
              <p className="text-gray-700 mb-4 max-w-xl">
                Per velocizzare l'attivazione dell'abbonamento, inviate la
                ricevuta di pagamento insieme al vostro indirizzo, numero di
                telefono e possibilmente la vostra email:
              </p>
            </div>

            <div className="flex justify-center">
              <ul className="list-inside text-gray-700 space-y-2 text-left ">
                <li>
                  <strong>Fax:</strong> 0584-45286
                </li>
                <li>
                  <strong>Email:</strong>{" "}
                  <a
                    href="mailto:abbonamenti@modellisticaint.it"
                    className="text-blue-500 underline"
                  >
                    abbonamenti@modellisticaint.it
                  </a>
                </li>
              </ul>
            </div>
          </div>
        ) : null}
      </div>
      <Footer />
    </div>
  );
};

export default AbbCartaceo;
